import { Box, Typography } from "@mui/material";
import CustomCopyButton from "../../../../../../components/CustomCopyButton";
import CustomToolTip from "../../../../../../components/CustomTooltip";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import {
  AD_ACCOUNT_OPTIONS_DISPLAY_NAMES,
  Platforms,
} from "../../../../../../utils/constants";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import { platformIcons } from "../../../utils";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import {
  getMacOSName,
  getWindowsOSName,
} from "../../entitiesCharts/hostChart/osVersionDistribution/osVersionHelpers";

const HostDetailsView = ({ entityData }) => {
  // This function checks if the uniqueId is a serial number or just uniqueId
  const isValidSerialNumber = (uniqueId) => {
    return !Object.values(Platforms).some((platform) =>
      uniqueId.startsWith(`${platform}_`)
    );
  };

  const getOSName = (entityData) => {
    return entityData?.platform === Platforms.WINDOWS
      ? getWindowsOSName(entityData?.os_version)
      : entityData?.platform === Platforms.MACOS
      ? getMacOSName(entityData?.os_version)
      : entityData?.os_version;
  };

  const platformIcon = platformIcons[entityData?.platform];
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {(entityData?.crowdstrike_data?.hostname ||
        entityData?.jamf_data?.hostname ||
        entityData?.intune_data?.name ||
        entityData?.microsoft_entra_id_data?.hostname ||
        entityData?.okta_data?.host_name ||
        entityData?.microsoft_defender_data?.host_name ||
        entityData?.paloalto_prisma_access_browser_data?.hostname ||
        entityData?.paloalto_talon_data?.hostname ||
        entityData?.addigy_data?.hostname ||
        entityData?.sentinel_one_data?.host_name ||
        entityData?.netskope_data?.hostname ||
        entityData?.jumpcloud_data?.hostname ||
        entityData?.kandji_data?.hostname ||
        entityData?.qualys_data?.hostname ||
        entityData?.microsoft_active_directory_data?.name) && (
        <Box display={"flex"} gap={1} alignItems={"center"}>
          <Typography variant="subtitle2" fontWeight="500">
            Host Name
          </Typography>
        </Box>
      )}
      <Box display={"flex"} flexDirection={"column"} gap={1} ml={3}>
        {entityData?.crowdstrike_data?.hostname && (
          <>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"crowdstrike"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.crowdstrike_data?.hostname}
            />
          </>
        )}
        {entityData?.jamf_data?.hostname && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage name={"jamf"} width={"16px"} newLogo={true} />
              </Box>
            }
            value={entityData?.jamf_data?.hostname}
          />
        )}
        {entityData?.intune_data?.name && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"intune"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.intune_data?.name}
          />
        )}
        {entityData?.addigy_data?.hostname && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"addigy"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.addigy_data?.hostname}
          />
        )}
        {entityData?.microsoft_entra_id_data?.hostname && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"microsoft_entra_id"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.microsoft_entra_id_data?.hostname}
          />
        )}
        {entityData?.microsoft_defender_data?.host_name && (
          <>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"microsoft_defender_endpoint"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.microsoft_defender_data?.host_name}
            />
          </>
        )}
        {entityData?.okta_data?.host_name && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage name={"okta"} width={"16px"} newLogo={true} />
              </Box>
            }
            value={entityData?.okta_data?.host_name}
          />
        )}
        {entityData?.paloalto_talon_data?.hostname && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"paloalto_talon"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.paloalto_talon_data?.hostname}
          />
        )}
        {entityData?.paloalto_prisma_access_browser_data?.hostname && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"paloalto_prisma_access_browser"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.paloalto_prisma_access_browser_data?.hostname}
          />
        )}
        {entityData?.sentinel_one_data?.host_name && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"sentinel_one"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.sentinel_one_data?.host_name}
          />
        )}
        {entityData?.netskope_data?.hostname && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"netskope"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.netskope_data?.hostname}
          />
        )}
        {entityData?.jumpcloud_data?.hostname && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"jumpcloud"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.jumpcloud_data?.hostname}
          />
        )}
        {entityData?.kandji_data?.hostname && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"kandji"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.kandji_data?.hostname}
          />
        )}
        {entityData?.qualys_data?.hostname && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"qualys"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.qualys_data?.hostname}
          />
        )}
        {entityData?.microsoft_active_directory_data?.name && (
          <TextIntegrationStyle
            title={
              <Box display={"flex"}>
                <IntegrationImage
                  name={"microsoft_active_directory"}
                  width={"16px"}
                  newLogo={true}
                />
              </Box>
            }
            value={entityData?.microsoft_active_directory_data?.name}
          />
        )}
      </Box>
      {(entityData?.microsoft_active_directory_data?.organizational_unit ||
        entityData?.crowdstrike_data?.organization_unit) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Organizational Unit</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={1} ml={3}>
            {entityData?.microsoft_active_directory_data
              ?.organizational_unit && (
              <TextIntegrationStyle
                title={""}
                value={
                  entityData?.microsoft_active_directory_data
                    ?.organizational_unit
                }
              ></TextIntegrationStyle>
            )}
            {entityData?.crowdstrike_data?.organization_unit && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"crowdstrike"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.crowdstrike_data?.organization_unit}
              />
            )}
          </Box>
        </Box>
      )}
      {entityData?.addigy_data?.device_model && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2" fontWeight="500">
              Device Model Name
            </Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"addigy"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.addigy_data?.device_model}
            />
          </Box>
        </Box>
      )}
      {entityData?.sentinel_one_data?.site_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Site Name</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"sentinel_one"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.sentinel_one_data?.site_name}
            />
          </Box>
        </Box>
      )}
      {entityData?.crowdstrike_data?.machine_domain && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Machine Domain</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"crowdstrike"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.crowdstrike_data?.machine_domain}
            />
          </Box>
        </Box>
      )}
      {(entityData?.sentinel_one_data?.domain ||
        entityData?.jumpcloud_data?.domain_name ||
        entityData?.microsoft_entra_id_data?.domain_name ||
        entityData?.microsoft_defender_data?.domain_name ||
        entityData?.servicenow_cmdb_data?.domain ||
        entityData?.microsoft_active_directory_data?.distinguished_name) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Domain</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            {entityData?.sentinel_one_data?.domain && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"sentinel_one"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.sentinel_one_data?.domain}
              />
            )}
            {entityData?.jumpcloud_data?.domain_name && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"jumpcloud"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.jumpcloud_data?.domain_name}
              />
            )}
            {entityData?.microsoft_entra_id_data?.domain_name && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"microsoft_entra_id"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.microsoft_entra_id_data?.domain_name}
              />
            )}
            {entityData?.microsoft_defender_data?.domain_name && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"microsoft_defender_endpoint"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.microsoft_defender_data?.domain_name}
              />
            )}
            {entityData?.servicenow_cmdb_data?.domain && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"servicenow_cmdb"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.servicenow_cmdb_data?.domain}
              />
            )}
            {entityData?.microsoft_active_directory_data
              ?.distinguished_name && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"microsoft_active_directory"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.microsoft_active_directory_data?.distinguished_name
                  .split(",")
                  .filter((part) => part.startsWith("DC="))
                  .map((part) => part.replace("DC=", ""))
                  .join(".")}
              />
            )}
          </Box>
        </Box>
      )}
      {entityData?.unique_id && isValidSerialNumber(entityData.unique_id) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Serial Number</Typography>
          </Box>
          <Box ml={2} display={"flex"} gap={2}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.unique_id}
            ></TextIntegrationStyle>
            <CustomCopyButton
              copyTitle={"serial number"}
              copyText={entityData?.unique_id}
            />
          </Box>
        </Box>
      )}
      {entityData?.platform && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Platform</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            {platformIcon ? (
              <TextIntegrationStyle
                title={""}
                value={
                  <CustomToolTip title={entityData?.platform}>
                    <Box display={"flex"} alignItems={"center"} gap={1}>
                      <SvgToIcon
                        IconLogo={platformIcon}
                        width={"16px"}
                      ></SvgToIcon>
                      <Typography variant="caption">
                        {entityData?.platform}
                      </Typography>
                    </Box>
                  </CustomToolTip>
                }
              ></TextIntegrationStyle>
            ) : (
              <TextIntegrationStyle title={""} value={entityData?.platform} />
            )}
          </Box>
        </Box>
      )}
      {entityData?.os_version &&
        entityData.os_version !== "None" &&
        getOSName(entityData) !== "" && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>OS Version</Typography>
            </Box>
            <Box ml={2} display={"flex"}>
              <TextIntegrationStyle
                title={""}
                value={getOSName(entityData)}
              ></TextIntegrationStyle>
            </Box>
          </Box>
        )}

      {entityData?.os_version && entityData.os_version !== "None" && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>OS Build</Typography>
          </Box>
          <Box ml={2} display={"flex"}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.os_version}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}

      {entityData?.microsoft_entra_id_data?.trust_type && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Trust Type</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"microsoft_entra_id"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={(() => {
                switch (entityData?.microsoft_entra_id_data?.trust_type) {
                  case "AzureAd":
                    return "Entra Joined Device";
                  case "Workplace":
                    return "Entra Registered Device";
                  case "ServerAd":
                    return "Entra Hybrid Joined Device";
                  default:
                    return entityData?.microsoft_entra_id_data?.trust_type;
                }
              })()}
            />
          </Box>
        </Box>
      )}
      {(entityData?.intune_data?.manufacturer ||
        entityData?.microsoft_entra_id_data?.manufacturer) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Manufacturer</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={1} ml={3}>
            {entityData?.intune_data?.manufacturer ===
            entityData?.microsoft_entra_id_data?.manufacturer ? (
              <Box display={"flex"} gap={1} flexDirection={"row"}>
                <IntegrationImage
                  name={"intune"}
                  width={"16px"}
                  newLogo={true}
                />
                <IntegrationImage
                  name={"microsoft_entra_id"}
                  width={"16px"}
                  newLogo={true}
                />
                <TextIntegrationStyle
                  title={""}
                  value={entityData?.intune_data?.manufacturer}
                ></TextIntegrationStyle>
              </Box>
            ) : (
              <Box>
                {entityData?.microsoft_entra_id_data?.manufacturer && (
                  <TextIntegrationStyle
                    title={
                      <Box display={"flex"}>
                        <IntegrationImage
                          name={"microsoft_entra_id"}
                          width={"16px"}
                          newLogo={true}
                        />
                      </Box>
                    }
                    value={entityData?.microsoft_entra_id_data?.manufacturer}
                  ></TextIntegrationStyle>
                )}
                {entityData?.intune_data?.manufacturer && (
                  <TextIntegrationStyle
                    title={
                      <Box display={"flex"}>
                        <IntegrationImage
                          name={"intune"}
                          width={"16px"}
                          newLogo={true}
                        />
                      </Box>
                    }
                    value={entityData?.intune_data?.manufacturer}
                  ></TextIntegrationStyle>
                )}
              </Box>
            )}
          </Box>
        </Box>
      )}
      {(entityData?.crowdstrike_data?.host_ip ||
        entityData?.microsoft_defender_data?.external_ip_address ||
        entityData?.microsoft_defender_data?.internal_ip_address ||
        entityData?.crowdstrike_data?.local_ip ||
        entityData?.rapid7_insight_vm_data?.public_ip ||
        entityData?.paloalto_talon_data?.host_ip ||
        entityData?.paloalto_prisma_access_browser_data?.host_ip ||
        entityData?.sentinel_one_data?.external_ip ||
        entityData?.cloudflare_ztna_data?.public_ip ||
        entityData?.kandji_data?.internal_ip_address ||
        entityData?.addigy_data?.internal_ip ||
        entityData?.addigy_data?.external_ip ||
        entityData?.jumpcloud_data?.remote_ip ||
        entityData?.qualys_data?.external_ip_address ||
        entityData?.qualys_data?.internal_ip_address ||
        entityData?.cato_data?.external_ip ||
        entityData?.cato_data?.internal_ip ||
        entityData?.servicenow_cmdb_data?.ip_address) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>IP Address</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={1} ml={3}>
            {entityData?.crowdstrike_data?.host_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"crowdstrike"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.crowdstrike_data?.host_ip + " (External)"}
              />
            )}
            {entityData?.crowdstrike_data?.local_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"crowdstrike"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.crowdstrike_data?.local_ip + " (Internal)"}
              />
            )}
            {entityData?.microsoft_defender_data?.external_ip_address && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"microsoft_defender_endpoint"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.microsoft_defender_data?.external_ip_address +
                  " (External)"
                }
              />
            )}
            {entityData?.microsoft_defender_data?.internal_ip_address && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"microsoft_defender_endpoint"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.microsoft_defender_data?.internal_ip_address +
                  " (Internal)"
                }
              />
            )}
            {entityData?.rapid7_insight_vm_data?.public_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"rapid7_insight_vm"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.rapid7_insight_vm_data?.public_ip + " (Internal)"
                }
              />
            )}
            {entityData?.paloalto_talon_data?.host_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"paloalto_talon"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.paloalto_talon_data?.host_ip + " (External)"}
              />
            )}
            {entityData?.paloalto_prisma_access_browser_data?.host_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"paloalto_prisma_access_browser"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.paloalto_prisma_access_browser_data?.host_ip +
                  " (External)"
                }
              />
            )}
            {entityData?.sentinel_one_data?.external_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"sentinel_one"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.sentinel_one_data?.external_ip + " (External)"
                }
              />
            )}
            {entityData?.cloudflare_ztna_data?.public_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"cloudflare"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.cloudflare_ztna_data?.public_ip + " (External)"
                }
              />
            )}
            {entityData?.jumpcloud_data?.remote_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"jumpcloud"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.jumpcloud_data?.remote_ip + " (External)"}
              />
            )}
            {entityData?.kandji_data?.internal_ip_address && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"kandji"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.kandji_data?.internal_ip_address + " (Internal)"
                }
              />
            )}
            {entityData?.addigy_data?.internal_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"addigy"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.addigy_data?.internal_ip + " (Internal)"}
              />
            )}
            {entityData?.addigy_data?.external_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"addigy"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.addigy_data?.external_ip + " (External)"}
              />
            )}
            {entityData?.qualys_data?.external_ip_address && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"qualys"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.qualys_data?.external_ip_address + " (External)"
                }
              />
            )}
            {entityData?.qualys_data?.internal_ip_address && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"qualys"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={
                  entityData?.qualys_data?.internal_ip_address + " (Internal)"
                }
              />
            )}
            {entityData?.servicenow_cmdb_data?.ip_address && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"servicenow_cmdb"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.servicenow_cmdb_data?.ip_address}
              />
            )}
            {entityData?.cato_data?.external_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"cato"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.cato_data?.external_ip + " (External)"}
              />
            )}
            {entityData?.cato_data?.internal_ip && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"cato"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.cato_data?.internal_ip + " (Internal)"}
              />
            )}
          </Box>
        </Box>
      )}
      {(entityData?.okta_data?.status ||
        entityData?.microsoft_active_directory_data?.status) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Status</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3} flexDirection={"column"}>
            {entityData?.okta_data?.status && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"okta"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.okta_data?.status}
              />
            )}
            {entityData?.microsoft_active_directory_data?.status && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"}>
                    <IntegrationImage
                      name={"microsoft_active_directory"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.microsoft_active_directory_data?.status}
              />
            )}
          </Box>
        </Box>
      )}
      {entityData?.sentinel_one_data?.group_name && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Group Name</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"sentinel_one"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.sentinel_one_data?.group_name}
            />
          </Box>
        </Box>
      )}
      {entityData?.jumpcloud_data?.azure_ad_member !== undefined && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Azure AD Member</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              value={
                entityData?.jumpcloud_data?.azure_ad_member ? "True" : "False"
              }
            />
          </Box>
        </Box>
      )}
      {(entityData?.microsoft_sccm_data?.user_account_control_flags?.length >
        0 ||
        entityData?.microsoft_active_directory_data?.user_account_control_flags
          ?.length > 0) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>AD Account Options</Typography>
          </Box>
          <Box display={"flex"} gap={1} ml={3} flexDirection={"column"}>
            {entityData?.microsoft_sccm_data?.user_account_control_flags?.map(
              (flag, index) => (
                <TextIntegrationStyle
                  key={`sccm-uac-flag-${index}`}
                  title={
                    <Box display={"flex"}>
                      <IntegrationImage
                        name={"microsoft_sccm"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={AD_ACCOUNT_OPTIONS_DISPLAY_NAMES[flag] || flag}
                />
              )
            )}
            {entityData?.microsoft_active_directory_data?.user_account_control_flags?.map(
              (flag, index) => (
                <TextIntegrationStyle
                  key={`ad-uac-flag-${index}`}
                  title={
                    <Box display={"flex"}>
                      <IntegrationImage
                        name={"microsoft_active_directory"}
                        width={"16px"}
                        newLogo={true}
                      />
                    </Box>
                  }
                  value={AD_ACCOUNT_OPTIONS_DISPLAY_NAMES[flag] || flag}
                />
              )
            )}
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.most_frequent_user && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Most Frequent User</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.most_frequent_user}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.responsible_group && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Responsible Group</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.responsible_group}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.company && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Company</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.company}
            />
          </Box>
        </Box>
      )}
      {entityData?.microsoft_active_directory_data?.allowed_to_delegate_to
        ?.length > 0 && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>
              Constrained Delegation Service
            </Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} gap={1} ml={2}>
            {entityData?.microsoft_active_directory_data?.allowed_to_delegate_to?.map(
              (item, idx) => (
                <TextIntegrationStyle key={idx} title={""} value={item} />
              )
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default HostDetailsView;
